export const defaultStyle = {
  container: "max-w-xl mx-auto",
  breadcrumbItems:
    "font-normal tracking-0.53 mb-0 box-border inline-flex cursor-pointer block block-start-8 flex flex-wrap",
  breadcrumbItemsStyle:
    "text-purple uppercase mb-0 flex text-left font-bold md:mt-0 tracking-[2px] md:tracking-[2.2px] text-[10px] md:text-[21px]  font-Regular bg-transparent leading-[1.5]",
  breadcrumbDevider: "px-[10px] cursor-text font-normal",
  headingOne:
    "block text-[36px] md:text-[60px] text-purple leading-[43.2px] md:leading-[1.2] tracking-[0.45px] md:tracking-[1.2px] font-MDLZBiteType inline-flex uppercase block block-start-8 text-left mb-[10px] md:mb-[20px]",
  paraUnderHeading: "paraUnderHeading text-[14px] md:text-[30px] text-black leading-[20px] md:leading-[40px] tracking-[0.35px] md:tracking-[0.75px] ",
  rightWrapper: "rightWrapper",
  newsLinksTwo:
    " newsLinks text-[14px] md:text-[21px] font-bold font-Regular text-purple hover:text-orange hover:underline tracking-[0.53px] md:tracking-[2.2px] leading-[31.5px]",
  newsLinksWrpr: "newsLinksWrpr after:content-['|'] last:after:content-['']",
  newsLinksContainer:
    " newsLinksContainer flex relative md:top-[5px] lg:top-[-18px] flex-wrap lg:justify-end",
  newsLinksOne: "text-black font-bold tracking-[0.53px] leading-[31.5px] pointer-events-none",
  ContainerFive:
    "ContainerFive md:tracking-[2.2px] md:text-[21px] text-[14px] tracking-[0.53px] font-Regular font-bold  text-purple hover:text-orange hover:underline text-right pb-[20px] relative right-0 bottom-[85px] md:bottom-[45px] lg:top-[35px] lg:pb-[30px] ",
  IconLinkCl: "float-end flex gap-[16px] items-center max-w-[340px] md:tracking-[2.2px] md:text-[21px] text-[14px] tracking-[0.53px] font-Regular font-bold  text-purple pb-[20px] relative right-0 bottom-0 mt-[10px] md:mt-[30px] lg:mt-0 md:bottom-[45px] lg:top-[35px] lg:pb-[30px] ",
  FaIcon: "fas fa-globe text-[25px] p-[10px] bg-[#f0e8f7] rounded-md",
  rightSection:
    "rightSection block lg:flex lg:justify-end pb-[10px] right-0  w-full lg:w-auto lg:min-w-[26%]",
  leftSection: "leftSection w-full lg:w-auto",
  headingDiv: "headingDiv block lg:flex lg:justify-between lg:items-end",
  SocialLink: "SocialLink md:flex md:mt-[10px] lg:absolute lg:-top-[10px] lg:right-0",
}

export const PARA_UNDER_HEADING = {
  ...defaultStyle,
  paraUnderHeading: " font-Regular font-bold text-[14px] text-left leading-[30px] tracking-[0.53px] md:text-[21px] ",
}
export const JOB_DETAIL_PAGE = {
  ...defaultStyle,
  container: "jobDetailPage max-w-xl mx-auto pt-[30px] lg:pt-[90px] pb-15 lg:pb-[30px]",
  SocialLink: "SocialLink md:flex md:mt-[10px] md:absolute md:top-10 md:right-0 lg:-top-[10px] lg:right-[15%] pt-[10px] lg:pt-[90px] pb-[30px] max-lg:ml-30",
  rightSection: "rightSection block justify-end pb-[10px] lg:pb-[25px] right-0 w-full lg:w-auto",
  }

  export const BREADCRUMB_NO_RIGHT_CONTENT = {
    container: "max-w-xl mx-auto",
    breadcrumbItems:
      "font-normal tracking-0.53 mb-0 box-border inline-flex cursor-pointer block block-start-8 flex flex-wrap",
    breadcrumbItemsStyle:
      "text-purple uppercase mb-0 flex text-left font-bold md:mt-0 tracking-[2px] md:tracking-[2.2px] text-[10px] md:text-[21px]  font-Regular bg-transparent leading-[1.5]",
    breadcrumbDevider: "px-[10px] cursor-text font-normal",
    headingOne:
      "block text-[36px] md:text-[60px] text-purple leading-[43.2px] md:leading-[1.2] tracking-[0.45px] md:tracking-[1.2px] font-MDLZBiteType inline-flex uppercase block block-start-8 text-left mb-[10px] md:mb-[20px]",
    paraUnderHeading: "paraUnderHeading text-[14px] md:text-[30px] text-black leading-[20px] md:leading-[40px] tracking-[0.35px] md:tracking-[0.75px] ",
    rightWrapper: "rightWrapper",
    newsLinksTwo:
      " newsLinks text-[14px] md:text-[21px] font-bold font-Regular text-purple hover:text-orange hover:underline tracking-[0.53px] md:tracking-[2.2px] leading-[31.5px]",
    newsLinksWrpr: "newsLinksWrpr after:content-['|'] last:after:content-['']",
    newsLinksContainer:
      " newsLinksContainer flex relative md:top-[5px] lg:top-[-18px] flex-wrap lg:justify-end",
    newsLinksOne: "text-black font-bold tracking-[0.53px] leading-[31.5px] pointer-events-none",
    ContainerFive:
      "flex gap-2 md:tracking-[2.2px] md:text-[21px] text-[14px] tracking-[0.53px] font-Regular font-bold  text-purple hover:text-orange hover:underline text-right pb-[20px] relative right-0 bottom-[85px] md:bottom-[45px] lg:top-[35px] lg:pb-[30px] ",
      rightSection: "rightSection",
    leftSection: "leftSection w-full lg:w-auto",
    headingDiv: "headingDiv block lg:flex lg:justify-between lg:items-end",
    SocialLink: "SocialLink md:flex md:mt-[10px] lg:absolute lg:-top-[10px] lg:right-0",
  }

  
export const INNER_BREADCRUMB_INLINE = {
  container: "",
  breadcrumbItems:"flex flex-wrap",
  breadcrumbItemsStyle:"text-white text-16 lg:text-20 leading-[24px] font-BwSurco font-medium",
  breadcrumbDevider: "pr-[5px]",
}
